export enum StorageKey {
    SerpCallBack = 'serpCallback',
    PdpCallBack = 'pdpCallback',
    UtmCampaign = 'utmCampaign',
}

export class SessionStorage {
    key: StorageKey;

    constructor(key: StorageKey) {
        this.key = key;
    }

    store(): void {
        const date = new Date();
        date.setMinutes(date.getMinutes() + 30);
        window.sessionStorage.setItem(this.key, date.toISOString());
    }

    expired(): boolean {
        const current = new Date();
        let session = null;

        try {
            session = window.sessionStorage.getItem(this.key);
        } catch (_) {
            // Can throw if cookies are not enabled.
            // If this throws, we want the error to end here, not bubble up.
        }

        if (session) {
            return Date.parse(current.toISOString()) > Date.parse(session);
        }
        return true;
    }

    isSet(): boolean {
        const session = window.sessionStorage.getItem(this.key);

        return !!session;
    }

    remove(): void {
        sessionStorage.removeItem(this.key);
    }
}
